type Props = {
  width?: string;
  height?: string;
  /** When set, the arrow matching this direction renders in `activeColor`; the other renders in `mutedColor`. */
  direction?: "asc" | "desc";
  activeColor?: string;
  mutedColor?: string;
  /** Color for both arrows when `direction` is unset (no sort applied) — solid, not muted. */
  neutralColor?: string;
};

export const IconSortUpDown = ({
  width = "1rem",
  height = "1rem",
  direction,
  activeColor = "currentColor",
  mutedColor = "currentColor",
  neutralColor = "currentColor",
}: Props) => {
  const upColor = direction === undefined ? neutralColor : direction === "desc" ? activeColor : mutedColor;
  const downColor = direction === undefined ? neutralColor : direction === "asc" ? activeColor : mutedColor;

  return (
    <span className="icon-sort-up-down" style={{ width, height }}>
      <svg width="100%" height="100%" viewBox="-1.5 -1.5 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 1V14M4.5 1L1.8 3.7M4.5 1L7.2 3.7" stroke={upColor} strokeWidth="1.75" strokeLinecap="round" />
        <path
          d="M11.5 15V2M11.5 15L14.2 12.3M11.5 15L8.8 12.3"
          stroke={downColor}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
};
